import { render, staticRenderFns } from "./scope85.vue?vue&type=template&id=51c8b7bd&scoped=true"
import script from "./scope85.vue?vue&type=script&lang=js"
export * from "./scope85.vue?vue&type=script&lang=js"
import style0 from "./scope85.vue?vue&type=style&index=0&id=51c8b7bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8b7bd",
  null
  
)

export default component.exports